// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/TDSansHeadline-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/TDSansHeadline-LightItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/TDSansHeadline-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/TDSansHeadline-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/TDSansHeadline-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/TDSansHeadline-BoldItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/TD Graphik-Semilight.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../fonts/TD Graphik-Semilight Italic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../fonts/TD Graphik-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../fonts/TD Graphik-Regular Italic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../fonts/TD Graphik-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../fonts/TD Graphik-Medium Italic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../fonts/TD Graphik-Semibold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../fonts/TD Graphik-Semibold Italic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../fonts/TD Graphik-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../fonts/TD Graphik-Bold Italic.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * BeHuman Design System tokens for IVA.
 * Source: /Users/JLee/Documents/Figma TD Test (BeHuman-DesignSystem + DESIGN.md)
 *
 * Strategy:
 * - Brand colors override the existing --td-green family (the BeHuman refresh
 *   IS the brand change).
 * - New semantic colors (red/amber/blue/teal) and BeHuman scales for type,
 *   spacing, radius, shadow are added as additive tokens.
 * - The original IVA fluid type scale (--font-2xs .. --font-3xl) is left
 *   intact in App.css; new --bh-* type tokens sit alongside.
 */

/* ── TD Sans Headline (WOFF2) — display / heading typeface ──────────── */
@font-face {
  font-family: 'TD Sans Headline';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2');
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'TD Sans Headline';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2');
  font-weight: 300;
  font-style: italic;
  font-display: swap;
}
@font-face {
  font-family: 'TD Sans Headline';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'TD Sans Headline';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff2');
  font-weight: 400;
  font-style: italic;
  font-display: swap;
}
/* Bold mapped to the 700–900 range — TD Sans Headline ships only one
   "Bold" cut, so 700 and 800 both render from the same file (no
   synthetic boldening). The BeHuman type scale uses 700/800. */
@font-face {
  font-family: 'TD Sans Headline';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff2');
  font-weight: 700 900;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'TD Sans Headline';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff2');
  font-weight: 700 900;
  font-style: italic;
  font-display: swap;
}

/* ── TD Graphik (OTF) — body / UI typeface ──────────────────────────── */
@font-face {
  font-family: 'TD Graphik';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('opentype');
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'TD Graphik';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('opentype');
  font-weight: 300;
  font-style: italic;
  font-display: swap;
}
@font-face {
  font-family: 'TD Graphik';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('opentype');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'TD Graphik';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('opentype');
  font-weight: 400;
  font-style: italic;
  font-display: swap;
}
@font-face {
  font-family: 'TD Graphik';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('opentype');
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'TD Graphik';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('opentype');
  font-weight: 500;
  font-style: italic;
  font-display: swap;
}
@font-face {
  font-family: 'TD Graphik';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format('opentype');
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'TD Graphik';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format('opentype');
  font-weight: 600;
  font-style: italic;
  font-display: swap;
}
@font-face {
  font-family: 'TD Graphik';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format('opentype');
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'TD Graphik';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format('opentype');
  font-weight: 700;
  font-style: italic;
  font-display: swap;
}

:root {
  /* ── Brand: TD shield green (BeHuman) ──────────────────────────────── */
  --td-green: #2FBF00;
  --td-dark-green: #259900;
  --td-green-dark: #259900;       /* alias used by some BeHuman snippets */
  --td-green-light: #E6F9E0;
  --td-accent: #2FBF00;           /* keep IVA name, point at brand green */

  /* ── Button-specific palette (May 2026 update) ────────────────────────
     Buttons use a slightly different green from the brand fill so they
     pop against the green-tinted hero gradients and balance cards. */
  --btn-primary:           #42BF19;   /* primary button fill */
  --btn-primary-hover:     #36A015;   /* primary on hover/press */
  --btn-primary-alt:       #002B1A;   /* primary alt — Premium Green fill */
  --btn-primary-alt-hover: #001A0F;
  --btn-secondary-outline: #002B1A;   /* secondary — Premium Green stroke */
  --btn-destructive:       #AE1100;   /* destructive primary — brick */
  --btn-destructive-hover: #8E0E00;

  /* ── Neutrals ──────────────────────────────────────────────────────── */
  --bh-black: #000000;
  --bh-dark: #333333;
  --bh-gray: #666666;
  --bh-light-gray: #F5F5F5;
  --bh-white: #FFFFFF;

  /* ── Semantic ──────────────────────────────────────────────────────── */
  --td-red: #D32F2F;
  --td-amber: #F59E0B;
  --td-blue: #2563EB;
  --td-teal: #448889;     /* BeHuman accent teal */

  /* ── Accent palette — for charts, categories, secondary indicators ── */
  --td-premium:   #002B1A;   /* Premium dark green — VIP / wealth tier */
  --td-shield:    #2FBF00;   /* Shield Green — alias of --td-green */
  --td-gold:      #CFBD91;
  --td-brown:     #7C5636;
  --td-tan:       #D9BFAF;
  --td-lavender:  #946E9F;
  --td-purple:    #462992;

  /* ── Soft accent pairs (May 2026) — saturated + pale companion.
     Use saturated for icons/borders/badges, soft for backgrounds. ── */
  --td-yellow:      #FEEF60;
  --td-yellow-soft: #FFF9BF;
  --td-pink:        #FEBFDA;
  --td-pink-soft:   #FFE5F0;
  --td-sky:         #A4D6DD;
  --td-sky-soft:    #DBEFF1;

  /* Chart palette (May 2026 refresh) — pastels-first, anchored on brand
     green + premium dark. Slots are ordered for default categorical data
     series; use --td-chart-1 first, then --td-chart-2, etc. */
  --td-chart-1: var(--td-shield);  /* primary brand */
  --td-chart-2: var(--td-sky);     /* pastel cool */
  --td-chart-3: var(--td-pink);    /* pastel warm */
  --td-chart-4: var(--td-yellow);  /* pastel bright */
  --td-chart-5: var(--td-teal);    /* deeper cool */
  --td-chart-6: var(--td-premium); /* anchor / "other" */
  /* Slots 7-8 only used by charts with >6 categories. Keep two
     off-brand hues for tail-end series so adjacent slices still differ. */
  --td-chart-7: var(--td-lavender);
  --td-chart-8: var(--td-gold);

  /* ── Typography ────────────────────────────────────────────────────── */
  --bh-font-heading: 'TD Sans Headline', 'Neue Haas Grotesk Display', 'Inter', 'SF Pro Display', system-ui, sans-serif;
  --bh-font-body:    'TD Graphik', 'Graphik', 'Inter', 'SF Pro Text', system-ui, sans-serif;
  --bh-font-mono:    'SF Mono', 'Menlo', monospace;

  /* BeHuman type scale — bolder than IVA's, used on refreshed screens.
     Existing screens keep using --font-* (clamp-based) until migrated. */
  --bh-display:  800 3rem/1.1     var(--bh-font-heading);
  --bh-h1:       800 2.25rem/1.2  var(--bh-font-heading);
  --bh-h2:       700 1.75rem/1.3  var(--bh-font-heading);
  --bh-h3:       700 1.375rem/1.4 var(--bh-font-heading);
  --bh-body-lg:  400 1.125rem/1.5 var(--bh-font-body);
  --bh-body:     400 1rem/1.5     var(--bh-font-body);
  --bh-body-sm:  400 0.875rem/1.4 var(--bh-font-body);
  --bh-caption:  400 0.75rem/1.3  var(--bh-font-body);
  --bh-overline: 600 0.6875rem/1.4 var(--bh-font-body);

  /* ── Spacing (8px baseline) ────────────────────────────────────────── */
  --space-3xs: 0.25rem;
  --space-2xs: 0.5rem;
  --space-xs:  0.75rem;
  --space-sm:  1rem;
  --space-md:  1.5rem;
  --space-lg:  2rem;
  --space-xl:  3rem;
  --space-2xl: 4rem;
  --space-3xl: 6rem;

  /* ── Radius ────────────────────────────────────────────────────────────
     Updated per BeHuman guideline (May 2026): sharp by default, BUT specific
     categories may have rounded corners. See styles/Guidelines.md for the
     full rules. Quick reference:
       Rounded → buttons, input fields, checkboxes, cards, tab items
       Sharp   → component surfaces, navigation items, dividers, holding
                 shapes, image containers
     The tokens below carry sensible rounded values so bh-* primitives that
     opt in (cards, buttons, inputs, etc.) get the right look automatically.
     Surfaces/nav/images explicitly set border-radius: 0 in App.css. */
  --radius-sm:   0.25rem;   /* 4px — small elements, badges */
  --radius-md:   0.5rem;    /* 8px — buttons, inputs, checkboxes, tabs */
  --radius-lg:   0.75rem;   /* 12px — cards */
  --radius-xl:   1rem;      /* 16px — large cards / containers */
  --radius-full: 9999px;    /* pills, avatars (when intentionally circular) */

  /* ── Shadows ───────────────────────────────────────────────────────── */
  --shadow-sm:    0 1px 2px rgba(0,0,0,0.05);
  --shadow-md:    0 1px 3px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.06);
  --shadow-lg:    0 3px 6px rgba(0,0,0,0.10), 0 2px 4px rgba(0,0,0,0.06);
  --shadow-xl:    0 10px 15px rgba(0,0,0,0.10), 0 4px 6px rgba(0,0,0,0.05);
  --shadow-green: 0 4px 14px rgba(47, 191, 0, 0.25);
}

/* ── Reusable BeHuman component primitives ──────────────────────────── */

.bh-btn-primary {
  background: var(--btn-primary);
  color: var(--bh-black);
  border: none;
  border-radius: var(--radius-md);
  padding: 12px 24px;
  font: var(--bh-body);
  font-weight: 700;
  min-height: 44px;
  cursor: pointer;
  transition: background 200ms ease-in-out, box-shadow 200ms ease-in-out, transform 200ms ease-in-out;
}
.bh-btn-primary:hover:not(:disabled) {
  background: var(--btn-primary-hover);
  box-shadow: var(--shadow-green);
}
.bh-btn-primary:active:not(:disabled) { transform: translateY(1px); }
.bh-btn-primary:disabled { opacity: 0.6; cursor: not-allowed; }

/* Primary alt — same shape as primary, Premium Green fill, white text. */
.bh-btn-primary-alt {
  background: var(--btn-primary-alt);
  color: var(--bh-white);
  border: none;
  border-radius: var(--radius-md);
  padding: 12px 24px;
  font: var(--bh-body);
  font-weight: 700;
  min-height: 44px;
  cursor: pointer;
  transition: background 200ms ease-in-out, box-shadow 200ms ease-in-out, transform 200ms ease-in-out;
}
.bh-btn-primary-alt:hover:not(:disabled) { background: var(--btn-primary-alt-hover); }
.bh-btn-primary-alt:active:not(:disabled) { transform: translateY(1px); }
.bh-btn-primary-alt:disabled { opacity: 0.6; cursor: not-allowed; }

/* Secondary — blank fill, Premium Green stroke. */
.bh-btn-secondary {
  background: transparent;
  color: var(--btn-secondary-outline);
  border: 1.5px solid var(--btn-secondary-outline);
  border-radius: var(--radius-md);
  padding: 10.5px 22.5px;
  font: var(--bh-body);
  font-weight: 700;
  min-height: 44px;
  cursor: pointer;
  transition: background 200ms ease-in-out, color 200ms ease-in-out;
}
.bh-btn-secondary:hover:not(:disabled) {
  background: var(--btn-primary-alt);
  color: var(--bh-white);
}

/* Destructive primary — brick fill, white text. Use for irreversible
   actions: delete, cancel-and-discard, freeze-card, report fraud. */
.bh-btn-destructive {
  background: var(--btn-destructive);
  color: var(--bh-white);
  border: none;
  border-radius: var(--radius-md);
  padding: 12px 24px;
  font: var(--bh-body);
  font-weight: 700;
  min-height: 44px;
  cursor: pointer;
  transition: background 200ms ease-in-out, box-shadow 200ms ease-in-out, transform 200ms ease-in-out;
}
.bh-btn-destructive:hover:not(:disabled) {
  background: var(--btn-destructive-hover);
  box-shadow: 0 4px 14px rgba(174, 17, 0, 0.25);
}
.bh-btn-destructive:active:not(:disabled) { transform: translateY(1px); }
.bh-btn-destructive:disabled { opacity: 0.6; cursor: not-allowed; }

.bh-input {
  box-sizing: border-box;
  width: 100%;
  height: 44px;
  border: 1px solid var(--bh-light-gray);
  border-radius: var(--radius-md);
  padding: 0 16px;
  font: var(--bh-body);
  color: var(--bh-black);
  background: var(--bh-white);
  outline: none;
  transition: border-color 200ms ease-in-out, box-shadow 200ms ease-in-out;
}
.bh-input::placeholder { color: var(--bh-gray); font-weight: 400; }
.bh-input:focus {
  border-color: var(--td-green);
  box-shadow: 0 0 0 3px var(--td-green-light);
}

.bh-card {
  background: var(--bh-white);
  border-radius: var(--radius-lg);
  border: 1px solid var(--bh-light-gray);
  padding: var(--space-md);
  box-shadow: var(--shadow-md);
  transition: box-shadow 200ms ease-in-out, transform 200ms ease-in-out;
}
.bh-card:hover { box-shadow: var(--shadow-lg); }

/* ── BeHuman Home (Banking-screen pattern) ────────────────────────── */

.bh-home { background: var(--bh-light-gray); }
.bh-home .bh-home-main {
  padding: var(--space-md) 0 var(--space-lg);
}

.bh-home-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--space-xs) var(--space-sm);
  background: var(--bh-white);
}
.bh-home-logo { height: 22px; width: auto; opacity: 0.95; }
.bh-icon-btn {
  background: transparent;
  border: none;
  color: var(--bh-black);
  font-size: var(--font-xl);
  width: 40px;
  height: 40px;
  border-radius: var(--radius-full);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 200ms ease-in-out;
}
.bh-icon-btn:hover { background: var(--bh-light-gray); }

/* Badged variant — shows the value of data-badge as a small red pill at
   the top-right of the icon. Hide when data-badge is "0" or empty. */
.bh-icon-btn--badged { position: relative; }
.bh-icon-btn--badged[data-badge]:not([data-badge="0"]):not([data-badge=""])::after {
  content: attr(data-badge);
  position: absolute;
  top: 4px;
  right: 4px;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  background: var(--td-red);
  color: var(--bh-white);
  font: var(--bh-caption);
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-full);
  pointer-events: none;
}

.bh-home-banner-wrapper {
  background: var(--bh-white);
  padding: 0 var(--space-sm) var(--space-2xs);
}

.bh-balance-hero {
  background: linear-gradient(180deg, var(--td-green) 0%, var(--td-dark-green) 100%);
  color: var(--bh-white);
  padding: var(--space-md);
  border-bottom-left-radius: var(--radius-xl);
  border-bottom-right-radius: var(--radius-xl);
  display: flex;
  flex-direction: column;
  gap: var(--space-md);
}
.bh-balance-hero-greeting { display: flex; flex-direction: column; }
.bh-balance-hero-eyebrow {
  margin: 0 0 var(--space-3xs);
  font: var(--bh-body-sm);
  opacity: 0.85;
}
.bh-balance-hero-name {
  margin: 0;
  font: var(--bh-h1);
  letter-spacing: -0.01em;
}

.bh-balance-card {
  background: var(--bh-black);
  color: var(--bh-white);
  border-radius: var(--radius-lg);
  padding: var(--space-md);
}
.bh-balance-card-label {
  margin: 0 0 var(--space-2xs);
  font: var(--bh-body-sm);
  opacity: 0.8;
}
.bh-balance-card-amount {
  margin: 0;
  font: var(--bh-display);
  letter-spacing: -0.02em;
}

.bh-section { padding: 0 var(--space-md); margin-top: var(--space-md); }
.bh-section:first-child { margin-top: 0; }
.bh-section-title {
  margin: 0 0 var(--space-sm);
  font: var(--bh-overline);
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--text-dark); /* themed: charcoal on light, cream on dark — sits on the screen bg, not a card */
}

.bh-qa-grid {
  display: flex;
  gap: var(--space-2xs);
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  /* bleed past section padding so cards reach the edge */
  margin-left: calc(-1 * var(--space-md));
  margin-right: calc(-1 * var(--space-md));
  padding-left: var(--space-md);
  padding-right: var(--space-md);
  padding-bottom: 4px;
}
.bh-qa-grid::-webkit-scrollbar { display: none; }
.bh-qa-grid .bh-qa-card {
  flex: 0 0 80px;
  scroll-snap-align: start;
}
.bh-qa-card {
  background: var(--bh-white);
  border: 1px solid var(--bh-light-gray);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  padding: var(--space-sm) var(--space-2xs);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-2xs);
  font: var(--bh-caption);
  color: var(--bh-dark);
  cursor: pointer;
  transition: box-shadow 200ms ease-in-out, transform 200ms ease-in-out;
}
.bh-qa-card:hover { box-shadow: var(--shadow-md); }
.bh-qa-card:active { transform: translateY(1px); }
.bh-qa-icon {
  width: 36px;
  height: 36px;
  border-radius: var(--radius-full);
  background: var(--td-green);
  color: var(--bh-black);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--font-lg);
}

.bh-account-list {
  display: flex;
  flex-direction: column;
  gap: var(--space-2xs);
}
.bh-account-card {
  background: var(--bh-white);
  border: 1px solid var(--bh-light-gray);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  padding: var(--space-sm);
  text-align: left;
  cursor: pointer;
  transition: box-shadow 200ms ease-in-out, transform 200ms ease-in-out;
  display: flex;
  flex-direction: column;
  gap: var(--space-3xs);
  width: 100%;
}
.bh-account-card:hover { box-shadow: var(--shadow-md); }
.bh-account-card-type {
  margin: 0;
  font: var(--bh-caption);
  color: var(--bh-gray);
}
.bh-account-card-balance {
  margin: 0;
  font: var(--bh-h2);
  color: var(--bh-black);
  letter-spacing: -0.01em;
}
.bh-account-card-balance.is-debt { color: var(--td-red); }
.bh-account-card-number {
  margin: 0;
  font: var(--bh-caption);
  color: var(--bh-gray);
}

/* ── BeHuman flow screens (e-Transfer pattern) ─────────────────────── */

.bh-flow {
  background: var(--bh-light-gray);
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
}

/* Green hero header — kit uses BLACK title on green for transactional flows.
   flex-shrink: 0 so the hero locks at its natural height and the
   .bh-flow-body below claims the remaining space for scroll. */
.bh-flow-hero {
  background: linear-gradient(135deg, var(--td-green) 0%, var(--td-dark-green) 100%);
  padding: var(--space-md) var(--space-md) var(--space-2xl);
  display: flex;
  align-items: center;
  gap: var(--space-2xs);
  color: var(--bh-black);
  justify-content: space-between;
  flex-shrink: 0;
}
.bh-flow-hero-left {
  display: flex;
  align-items: center;
  gap: var(--space-2xs);
  min-width: 0;
  flex: 1 1;
}
.bh-flow-back {
  background: transparent;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: var(--radius-full);
  color: var(--bh-black);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 26px;
  transition: background-color 200ms ease-in-out;
}
.bh-flow-back:hover { background: rgba(0,0,0,0.08); }
.bh-flow-title {
  margin: 0;
  font: var(--bh-h2);
  letter-spacing: -0.01em;
  color: var(--bh-black);
}

/* Form/content area lifts up over the hero for the "stacked card" feel.
   min-height: 0 + flex: 1 lets the body claim the remaining vertical space
   and scroll its own content (transaction lists, long forms). A thin
   gray scrollbar makes the scroll affordance visible — earlier we hid it
   for cleanliness, but users couldn't tell they could scroll. */
.bh-flow-body {
  margin-top: calc(-1 * var(--space-md));
  padding: 0 var(--space-md) var(--space-lg);
  display: flex;
  flex-direction: column;
  gap: var(--space-md);
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.18) transparent;
}
/* The body is a scrolling flex column, so its cards must keep their natural
   height and let the body scroll — never shrink to fit. Without this, a card
   with \`overflow:hidden\` (whose flex auto-min-height collapses to 0) gets
   squeezed and clips its own content (e.g. the Rewards points hero). Inline
   \`flex\` on a child still wins, so intentional grow/shrink is unaffected. */
.bh-flow-body > * { flex-shrink: 0; }
.bh-flow-body::-webkit-scrollbar { width: 6px; }
.bh-flow-body::-webkit-scrollbar-track { background: transparent; }
.bh-flow-body::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.18);
  border-radius: 0;
}
.bh-flow-body::-webkit-scrollbar-thumb:hover { background: rgba(0, 0, 0, 0.32); }

.bh-form-card {
  background: var(--bh-white);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-md);
  padding: var(--space-md);
  display: flex;
  flex-direction: column;
  gap: var(--space-sm);
}
.bh-form-card-title {
  margin: 0 0 var(--space-2xs);
  font: var(--bh-h3);
  color: var(--bh-black);
}

.bh-field { display: flex; flex-direction: column; gap: var(--space-3xs); }
.bh-field-label {
  font: var(--bh-body-sm);
  font-weight: 600;
  color: var(--bh-black);
  display: inline-flex;
  align-items: center;
  gap: var(--space-3xs);
}
.bh-field-input,
.bh-field-textarea,
.bh-field-select {
  width: 100%;
  background: var(--bh-light-gray);
  border: 2px solid #E5E7EB;
  border-radius: var(--radius-md);
  padding: 12px 16px;
  font: var(--bh-body);
  color: var(--bh-black);
  outline: none;
  transition: border-color 200ms ease-in-out, background 200ms ease-in-out;
  appearance: none;
  -webkit-appearance: none;
}
.bh-field-input:focus,
.bh-field-textarea:focus,
.bh-field-select:focus {
  border-color: var(--td-green);
  background: var(--bh-white);
}
.bh-field-input.is-error,
.bh-field-textarea.is-error,
.bh-field-select.is-error { border-color: var(--td-red); }
.bh-field-input.is-amount {
  font: var(--bh-h2);
  font-weight: 700;
  letter-spacing: -0.01em;
}
.bh-field-textarea { resize: vertical; min-height: 80px; }
.bh-field-error {
  margin-top: var(--space-3xs);
  font: var(--bh-caption);
  color: var(--td-red);
}

/* Buttons — kit uses BLACK text on green CTAs and BLACK fill for confirm.
   Primary fill is var(--btn-primary) per the May 2026 button-color update. */
.bh-btn-cta {
  background: var(--btn-primary);
  color: var(--bh-black);
  border: none;
  border-radius: var(--radius-md);
  padding: 16px 24px;
  width: 100%;
  font: var(--bh-body);
  font-weight: 700;
  min-height: 52px;
  cursor: pointer;
  transition: background 200ms ease-in-out, box-shadow 200ms ease-in-out, transform 200ms ease-in-out;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2xs);
}
.bh-btn-cta:hover:not(:disabled) {
  background: var(--btn-primary-hover);
  box-shadow: var(--shadow-green);
}
.bh-btn-cta:active:not(:disabled) { transform: translateY(1px); }
.bh-btn-cta:disabled { opacity: 0.55; cursor: not-allowed; }

.bh-btn-dark {
  background: var(--bh-black);
  color: var(--bh-white);
  border: none;
  border-radius: var(--radius-md);
  padding: 14px 20px;
  font: var(--bh-body);
  font-weight: 700;
  min-height: 48px;
  cursor: pointer;
  transition: background 200ms ease-in-out, transform 200ms ease-in-out;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2xs);
}
.bh-btn-dark:hover:not(:disabled) { background: #1a1a1a; }
.bh-btn-dark:active:not(:disabled) { transform: translateY(1px); }

.bh-btn-outline-dark {
  background: var(--bh-white);
  color: var(--bh-black);
  border: 2px solid var(--bh-black);
  border-radius: var(--radius-md);
  padding: 12px 20px;
  font: var(--bh-body);
  font-weight: 700;
  min-height: 48px;
  cursor: pointer;
  transition: background 200ms ease-in-out;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2xs);
}
.bh-btn-outline-dark:hover { background: var(--bh-light-gray); }

.bh-btn-row { display: flex; gap: var(--space-2xs); }
.bh-btn-row > * { flex: 1 1; }

/* Avatar circle — green fill, BLACK initials */
.bh-avatar {
  border-radius: var(--radius-full);
  background: var(--td-green);
  color: var(--bh-black);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font: var(--bh-body);
  font-weight: 700;
}
.bh-avatar.size-md { width: 48px; height: 48px; font-size: 1rem; }
.bh-avatar.size-lg { width: 64px; height: 64px; font-size: 1.25rem; }
.bh-avatar.size-xl { width: 88px; height: 88px; font-size: 1.75rem; }

/* Recent transfers list — single white card, rows with hairlines (kit pattern) */
.bh-recent-list {
  background: var(--bh-white);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
}
.bh-recent-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--space-sm);
  padding: var(--space-sm);
  /* width:100% + padding must include the padding, or the row overflows its
     (overflow:hidden) list and clips the right-side amounts. */
  box-sizing: border-box;
  border-bottom: 1px solid var(--bh-light-gray);
  cursor: pointer;
  background: transparent;
  border-left: none;
  border-right: none;
  border-top: none;
  width: 100%;
  text-align: left;
  transition: background 200ms ease-in-out;
}
.bh-recent-row:last-child { border-bottom: none; }
.bh-recent-row:hover { background: var(--bh-light-gray); }
.bh-recent-row-info { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
.bh-recent-row-name {
  font: var(--bh-body-sm);
  font-weight: 600;
  color: var(--bh-black);
}
.bh-recent-row-date { font: var(--bh-caption); color: var(--bh-gray); }
.bh-recent-row-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  flex-shrink: 0;
}
.bh-recent-row-amount {
  font: var(--bh-body-sm);
  font-weight: 700;
  color: var(--bh-black);
}
.bh-recent-row-status {
  font: var(--bh-caption);
  color: var(--td-green);
}

/* Account radio rows inside a form card */
.bh-account-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--space-sm);
  background: var(--bh-light-gray);
  border: 2px solid #E5E7EB;
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: border-color 200ms ease-in-out, background 200ms ease-in-out;
}
.bh-account-row:hover { background: var(--bh-white); }
.bh-account-row.selected {
  border-color: var(--td-green);
  background: var(--td-green-light);
}
.bh-account-row-info { display: flex; flex-direction: column; gap: 2px; }
.bh-account-row-name {
  font: var(--bh-body);
  font-weight: 600;
  color: var(--bh-black);
}
.bh-account-row-num { font: var(--bh-caption); color: var(--bh-gray); }
.bh-account-row-balance {
  font: var(--bh-body);
  font-weight: 700;
  color: var(--bh-black);
}

/* 2-line account picker (used where a single-line <select> wouldn't fit) */
.bh-acct-picker {
  background: var(--bh-light-gray);
  border: 2px solid #E5E7EB;
  border-radius: var(--radius-md);
  overflow: hidden;
  transition: border-color 200ms ease-in-out;
}
.bh-acct-picker[data-open="true"] { border-color: var(--td-green); background: var(--bh-white); }

.bh-acct-row {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-sm);
  padding: 10px var(--space-sm);
  background: transparent;
  border: none;
  text-align: left;
  cursor: pointer;
  transition: background 200ms ease-in-out;
  min-height: auto;
  color: var(--bh-black);
  font: var(--bh-body);
}
.bh-acct-row:hover { background: rgba(47, 191, 0, 0.06); }

.bh-acct-row-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1 1;
}
.bh-acct-row-name {
  font: var(--bh-body);
  font-weight: 600;
  color: var(--bh-black);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.bh-acct-row-meta {
  display: flex;
  justify-content: space-between;
  gap: var(--space-2xs);
  font: var(--bh-caption);
  color: var(--bh-gray);
}
.bh-acct-row-meta > span:last-child {
  color: var(--bh-black);
  font-weight: 600;
  white-space: nowrap;
}

.bh-acct-chevron {
  flex-shrink: 0;
  color: var(--bh-dark);
  transition: transform 200ms ease-in-out;
}
.bh-acct-picker[data-open="true"] .bh-acct-chevron { transform: rotate(180deg); }

.bh-acct-options {
  border-top: 1px solid var(--bh-light-gray);
  display: flex;
  flex-direction: column;
}
.bh-acct-options .bh-acct-row + .bh-acct-row {
  border-top: 1px solid var(--bh-light-gray);
}

/* Quick amount chips */
.bh-quick-amounts { display: flex; gap: var(--space-2xs); flex-wrap: wrap; }
.bh-quick-amount {
  background: var(--bh-white);
  border: 2px solid #E5E7EB;
  border-radius: var(--radius-full);
  padding: 8px 16px;
  font: var(--bh-body-sm);
  font-weight: 600;
  color: var(--bh-black);
  cursor: pointer;
  transition: background 200ms ease-in-out, border-color 200ms ease-in-out;
}
.bh-quick-amount:hover { background: var(--bh-light-gray); }
.bh-quick-amount.selected {
  background: var(--td-green);
  border-color: var(--td-green);
}

/* Review rows */
.bh-review-rows {
  display: flex;
  flex-direction: column;
  gap: var(--space-2xs);
  border-top: 1px solid var(--bh-light-gray);
  border-bottom: 1px solid var(--bh-light-gray);
  padding: var(--space-sm) 0;
}
.bh-review-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: var(--space-sm);
  font: var(--bh-body-sm);
}
.bh-review-row-label { color: var(--bh-gray); }
.bh-review-row-value {
  font-weight: 600;
  color: var(--bh-black);
  text-align: right;
}

.bh-info-box {
  background: var(--bh-light-gray);
  border-radius: var(--radius-md);
  padding: var(--space-sm);
  font: var(--bh-caption);
  color: var(--bh-gray);
  line-height: 1.5;
}

/* Success state */
.bh-success-icon {
  width: 80px;
  height: 80px;
  border-radius: var(--radius-full);
  background: var(--td-green);
  color: var(--bh-black);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}
.bh-success-title {
  margin: 0;
  font: var(--bh-h2);
  text-align: center;
  color: var(--bh-black);
}
.bh-success-subtitle {
  margin: 0;
  font: var(--bh-body);
  text-align: center;
  color: var(--bh-gray);
}

/* Big amount display (review/success) */
.bh-amount-display {
  margin: 0;
  font: var(--bh-display);
  font-weight: 800;
  letter-spacing: -0.02em;
  color: var(--td-green);
  text-align: center;
}

/* ── High-net-worth premium theme (Investing screen) ───────────────────
   Black + gold dual-tone — used on .port-screen for the wealth
   management aesthetic. Avoids the bright shield-green; gold replaces
   green as the positive accent. */
.port-screen .bh-flow-hero.dark {
  background: linear-gradient(135deg, var(--td-premium) 0%, var(--bh-black) 70%, #1a1a1a 100%);
  border-bottom: 1px solid var(--td-gold);
}
.port-screen .bh-flow-title { color: var(--td-gold); }

.bh-btn-gold {
  background: var(--td-gold);
  color: var(--bh-black);
  border: none;
  padding: 14px 24px;
  width: 100%;
  font: var(--bh-body);
  font-weight: 700;
  min-height: 52px;
  cursor: pointer;
  transition: background 200ms ease-in-out, box-shadow 200ms ease-in-out, transform 200ms ease-in-out;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2xs);
}
.bh-btn-gold:hover:not(:disabled) {
  background: #BBA77B;
  box-shadow: 0 4px 14px rgba(207, 189, 145, 0.35);
}
.bh-btn-gold:active:not(:disabled) { transform: translateY(1px); }

/* Tall hero — fits a balance card (and optionally an action card) under
   the title row. flex-shrink: 0 inherited from .bh-flow-hero. */
.bh-flow-hero.tall {
  flex-direction: column;
  align-items: stretch;
  gap: var(--space-md);
  padding: var(--space-md);
  padding-bottom: var(--space-2xl);
}
.bh-flow-hero.tall .bh-flow-hero-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2xs);
}

/* AccountDetailsScreen single-scroll layout: hero + balance + actions +
   tabs + transactions all scroll together inside .scroll-content. The
   content lifts up over the green hero the same way .bh-flow-body does,
   but is otherwise a plain block stack (no flex split, no overflow trap). */
.account-details-content {
  margin-top: calc(-1 * var(--space-md));
  padding: 0 var(--space-md) var(--space-lg);
  display: flex;
  flex-direction: column;
  gap: var(--space-md);
  position: relative;
  z-index: 1;
}

/* Dark hero variant — used for non-transactional account/product pages */
.bh-flow-hero.dark {
  background: var(--bh-black);
  color: var(--bh-white);
}
.bh-flow-hero.dark .bh-flow-back,
.bh-flow-hero.dark .bh-flow-title { color: var(--bh-white); }
.bh-flow-hero.dark .bh-flow-back:hover { background: rgba(255,255,255,0.12); }
.bh-flow-hero-subtitle {
  margin: var(--space-3xs) 0 0;
  font: var(--bh-body-sm);
  opacity: 0.85;
}

/* Pagination dots */
.bh-dots {
  display: flex;
  gap: 6px;
  justify-content: center;
  padding: var(--space-2xs) 0;
}
.bh-dot {
  width: 6px;
  height: 6px;
  border-radius: var(--radius-full);
  background: var(--bh-light-gray);
  display: inline-block;
  transition: width 200ms ease-in-out, background 200ms ease-in-out;
}
.bh-dot.active { background: var(--td-green); width: 18px; }

/* Centered balance block inside a card (eyebrow + big amount) */
.bh-hero-card-balance { text-align: center; padding: var(--space-2xs) 0; }
.bh-hero-card-eyebrow {
  display: block;
  font: var(--bh-overline);
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--bh-gray);
  margin-bottom: var(--space-3xs);
}
.bh-hero-card-amount {
  margin: 0;
  font: var(--bh-display);
  font-weight: 800;
  color: var(--bh-black);
  letter-spacing: -0.02em;
}

/* Action row (Pay/Transfer/Deposit etc.) — inside a form card */
.bh-action-row {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--space-2xs);
}
/* Carousel variant — horizontally scrollable, snap-to-card */
.bh-action-carousel {
  display: flex;
  gap: var(--space-2xs);
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  padding-bottom: 2px;
}
.bh-action-carousel::-webkit-scrollbar { display: none; }
.bh-action-carousel .bh-action-card {
  flex: 0 0 72px;
  scroll-snap-align: start;
}
.bh-action-card {
  background: var(--bh-light-gray);
  border: none;
  border-radius: var(--radius-lg);
  padding: var(--space-sm) var(--space-2xs);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-2xs);
  cursor: pointer;
  font: var(--bh-caption);
  font-weight: 600;
  color: var(--bh-black);
  transition: background 200ms ease-in-out, transform 200ms ease-in-out;
}
.bh-action-card:hover { background: var(--td-green-light); }
.bh-action-card:active { transform: translateY(1px); }
.bh-action-card-icon {
  width: 40px;
  height: 40px;
  border-radius: var(--radius-full);
  background: var(--td-green);
  color: var(--bh-black);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--font-lg);
}

/* Pill segmented tabs */
.bh-tabs {
  display: flex;
  gap: 4px;
  background: var(--bh-light-gray);
  padding: 4px;
  border-radius: var(--radius-full);
}
.bh-tab {
  flex: 1 1;
  background: transparent;
  border: none;
  padding: 10px var(--space-sm);
  border-radius: var(--radius-full);
  font: var(--bh-body-sm);
  font-weight: 600;
  color: var(--bh-gray);
  cursor: pointer;
  transition: background 200ms ease-in-out, color 200ms ease-in-out, box-shadow 200ms ease-in-out;
}
.bh-tab.active {
  background: var(--bh-white);
  color: var(--bh-black);
  box-shadow: var(--shadow-sm);
}

/* Transaction list — single white card, group titles, hairline rows */
.bh-tx-list {
  background: var(--bh-white);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
}
.bh-tx-group-title {
  padding: var(--space-2xs) var(--space-sm);
  background: var(--bh-light-gray);
  font: var(--bh-overline);
  text-transform: uppercase;
  color: var(--bh-gray);
}
.bh-tx-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--space-sm);
  padding: var(--space-sm);
  border-bottom: 1px solid var(--bh-light-gray);
}
.bh-tx-row:last-child { border-bottom: none; }
.bh-tx-row-info { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
.bh-tx-merchant {
  font: var(--bh-body-sm);
  font-weight: 600;
  color: var(--bh-black);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.bh-tx-date {
  font: var(--bh-caption);
  color: var(--bh-gray);
}
.bh-tx-amount {
  font: var(--bh-body-sm);
  font-weight: 700;
  color: var(--bh-black);
  flex-shrink: 0;
}
.bh-tx-amount.positive { color: var(--td-green); }

/* Product card (loan/credit/savings products) */
.bh-product-card {
  background: var(--bh-white);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--bh-light-gray);
  padding: var(--space-md);
  display: flex;
  flex-direction: column;
  gap: var(--space-2xs);
}
.bh-product-card-title {
  margin: 0;
  font: var(--bh-h3);
  color: var(--bh-black);
}
.bh-product-card-rate {
  margin: 0;
  font: var(--bh-h2);
  font-weight: 800;
  color: var(--td-green);
  letter-spacing: -0.01em;
}
.bh-product-card-desc {
  margin: 0;
  font: var(--bh-body-sm);
  color: var(--bh-dark);
  line-height: 1.5;
}
.bh-product-card-features {
  margin: var(--space-2xs) 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: var(--space-3xs);
}
.bh-product-card-features li {
  font: var(--bh-body-sm);
  color: var(--bh-dark);
  display: flex;
  align-items: flex-start;
  gap: var(--space-2xs);
}
.bh-product-card-features li::before {
  content: '✓';
  color: var(--td-green);
  font-weight: 700;
  flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./src/styles/theme.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;EAWE;;AAIF,0EAA0E;AAC1E;EACE,+BAA+B;EAC/B,4DAA+D;EAC/D,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,+BAA+B;EAC/B,4DAAqE;EACrE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,+BAA+B;EAC/B,4DAAiE;EACjE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,+BAA+B;EAC/B,4DAAgE;EAChE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;;+DAE+D;AAC/D;EACE,+BAA+B;EAC/B,4DAA8D;EAC9D,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,+BAA+B;EAC/B,4DAAoE;EACpE,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,0EAA0E;AAC1E;EACE,yBAAyB;EACzB,+DAAgE;EAChE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,+DAAuE;EACvE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,+DAA8D;EAC9D,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,+DAAqE;EACrE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,gEAA6D;EAC7D,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,gEAAoE;EACpE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,gEAA+D;EAC/D,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,gEAAsE;EACtE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,gEAA2D;EAC3D,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,gEAAkE;EAClE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yEAAyE;EACzE,mBAAmB;EACnB,wBAAwB;EACxB,wBAAwB,QAAQ,wCAAwC;EACxE,yBAAyB;EACzB,oBAAoB,YAAY,wCAAwC;;EAExE;;qEAEmE;EACnE,gCAAgC,IAAI,wBAAwB;EAC5D,gCAAgC,IAAI,2BAA2B;EAC/D,gCAAgC,IAAI,qCAAqC;EACzE,gCAAgC;EAChC,gCAAgC,IAAI,qCAAqC;EACzE,gCAAgC,IAAI,gCAAgC;EACpE,gCAAgC;;EAEhC,yEAAyE;EACzE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;;EAEnB,yEAAyE;EACzE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB,MAAM,wBAAwB;;EAEhD,wEAAwE;EACxE,uBAAuB,IAAI,2CAA2C;EACtE,uBAAuB,IAAI,uCAAuC;EAClE,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;;EAEvB;uEACqE;EACrE,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;;EAEzB;;8DAE4D;EAC5D,8BAA8B,GAAG,kBAAkB;EACnD,2BAA2B,MAAM,gBAAgB;EACjD,4BAA4B,KAAK,gBAAgB;EACjD,8BAA8B,GAAG,kBAAkB;EACnD,4BAA4B,KAAK,gBAAgB;EACjD,+BAA+B,EAAE,qBAAqB;EACtD;0EACwE;EACxE,gCAAgC;EAChC,4BAA4B;;EAE5B,yEAAyE;EACzE,oHAAoH;EACpH,yFAAyF;EACzF,gDAAgD;;EAEhD;yEACuE;EACvE,sDAAsD;EACtD,sDAAsD;EACtD,sDAAsD;EACtD,sDAAsD;EACtD,mDAAmD;EACnD,mDAAmD;EACnD,mDAAmD;EACnD,mDAAmD;EACnD,oDAAoD;;EAEpD,yEAAyE;EACzE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;;EAEjB;;;;;;;;;sEASoE;EACpE,sBAAsB,IAAI,iCAAiC;EAC3D,qBAAqB,KAAK,4CAA4C;EACtE,sBAAsB,IAAI,iBAAiB;EAC3C,mBAAmB,OAAO,oCAAoC;EAC9D,qBAAqB,KAAK,iDAAiD;;EAE3E,yEAAyE;EACzE,0CAA0C;EAC1C,sEAAsE;EACtE,sEAAsE;EACtE,wEAAwE;EACxE,iDAAiD;AACnD;;AAEA,0EAA0E;;AAE1E;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mGAAmG;AACrG;AACA;EACE,oCAAoC;EACpC,+BAA+B;AACjC;AACA,wCAAwC,0BAA0B,EAAE;AACpE,2BAA2B,YAAY,EAAE,mBAAmB,EAAE;;AAE9D,yEAAyE;AACzE;EACE,kCAAkC;EAClC,sBAAsB;EACtB,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mGAAmG;AACrG;AACA,2CAA2C,wCAAwC,EAAE;AACrF,4CAA4C,0BAA0B,EAAE;AACxE,+BAA+B,YAAY,EAAE,mBAAmB,EAAE;;AAElE,kDAAkD;AAClD;EACE,uBAAuB;EACvB,mCAAmC;EACnC,gDAAgD;EAChD,+BAA+B;EAC/B,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iEAAiE;AACnE;AACA;EACE,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;oEACoE;AACpE;EACE,kCAAkC;EAClC,sBAAsB;EACtB,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mGAAmG;AACrG;AACA;EACE,wCAAwC;EACxC,6CAA6C;AAC/C;AACA,4CAA4C,0BAA0B,EAAE;AACxE,+BAA+B,YAAY,EAAE,mBAAmB,EAAE;;AAElE;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,+BAA+B;EAC/B,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;EACb,wEAAwE;AAC1E;AACA,yBAAyB,qBAAqB,EAAE,gBAAgB,EAAE;AAClE;EACE,6BAA6B;EAC7B,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,sCAAsC;EACtC,wBAAwB;EACxB,4BAA4B;EAC5B,qEAAqE;AACvE;AACA,iBAAiB,4BAA4B,EAAE;;AAE/C,wEAAwE;;AAExE,WAAW,gCAAgC,EAAE;AAC7C;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,wCAAwC;EACxC,2BAA2B;AAC7B;AACA,gBAAgB,YAAY,EAAE,WAAW,EAAE,aAAa,EAAE;AAC1D;EACE,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,8CAA8C;AAChD;AACA,qBAAqB,gCAAgC,EAAE;;AAEvD;qEACqE;AACrE,uBAAuB,kBAAkB,EAAE;AAC3C;EACE,yBAAyB;EACzB,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,kFAAkF;EAClF,sBAAsB;EACtB,wBAAwB;EACxB,2CAA2C;EAC3C,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;AACA,4BAA4B,aAAa,EAAE,sBAAsB,EAAE;AACnE;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,+BAA+B;EAC/B,wBAAwB;AAC1B;AACA;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,SAAS;EACT,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA,cAAc,0BAA0B,EAAE,2BAA2B,EAAE;AACvE,0BAA0B,aAAa,EAAE;AACzC;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB,EAAE,iFAAiF;AAC5G;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,gBAAgB;EAChB,6BAA6B;EAC7B,iCAAiC;EACjC,qBAAqB;EACrB,uDAAuD;EACvD,uCAAuC;EACvC,wCAAwC;EACxC,6BAA6B;EAC7B,8BAA8B;EAC9B,mBAAmB;AACrB;AACA,iCAAiC,aAAa,EAAE;AAChD;EACE,cAAc;EACd,wBAAwB;AAC1B;AACA;EACE,2BAA2B;EAC3B,sCAAsC;EACtC,+BAA+B;EAC/B,4BAA4B;EAC5B,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;EACf,qEAAqE;AACvE;AACA,oBAAoB,4BAA4B,EAAE;AAClD,qBAAqB,0BAA0B,EAAE;AACjD;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,2BAA2B;EAC3B,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,2BAA2B;EAC3B,sCAAsC;EACtC,+BAA+B;EAC/B,4BAA4B;EAC5B,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,qEAAqE;EACrE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;AACb;AACA,yBAAyB,4BAA4B,EAAE;AACvD;EACE,SAAS;EACT,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;AACzB;AACA,mCAAmC,oBAAoB,EAAE;AACzD;EACE,SAAS;EACT,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA,yEAAyE;;AAEzE;EACE,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;AACf;;AAEA;;+DAE+D;AAC/D;EACE,kFAAkF;EAClF,yDAAyD;EACzD,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,8BAA8B;EAC9B,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,SAAO;AACT;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,8CAA8C;AAChD;AACA,sBAAsB,4BAA4B,EAAE;AACpD;EACE,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;;;;gEAIgE;AAChE;EACE,sCAAsC;EACtC,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,4BAA4B;EAC5B,iCAAiC;EACjC,qBAAqB;EACrB,gDAAgD;AAClD;AACA;;;;4EAI4E;AAC5E,oBAAoB,cAAc,EAAE;AACpC,mCAAmC,UAAU,EAAE;AAC/C,yCAAyC,uBAAuB,EAAE;AAClE;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;AACA,+CAA+C,+BAA+B,EAAE;;AAEhF;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,4BAA4B;EAC5B,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,YAAY,aAAa,EAAE,sBAAsB,EAAE,qBAAqB,EAAE;AAC1E;EACE,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;AACvB;AACA;;;EAGE,WAAW;EACX,gCAAgC;EAChC,yBAAyB;EACzB,+BAA+B;EAC/B,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;EACtB,aAAa;EACb,wEAAwE;EACxE,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;;;EAGE,6BAA6B;EAC7B,2BAA2B;AAC7B;AACA;;4BAE4B,2BAA2B,EAAE;AACzD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;AACA,qBAAqB,gBAAgB,EAAE,gBAAgB,EAAE;AACzD;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;6EAC6E;AAC7E;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mGAAmG;EACnG,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,oCAAoC;EACpC,+BAA+B;AACjC;AACA,oCAAoC,0BAA0B,EAAE;AAChE,uBAAuB,aAAa,EAAE,mBAAmB,EAAE;;AAE3D;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,qEAAqE;EACrE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;AACA,oCAAoC,mBAAmB,EAAE;AACzD,qCAAqC,0BAA0B,EAAE;;AAEjE;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,iCAAiC;EACjC,+BAA+B;EAC/B,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,wCAAwC;EACxC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;AACA,6BAA6B,gCAAgC,EAAE;;AAE/D,cAAc,aAAa,EAAE,qBAAqB,EAAE;AACpD,kBAAkB,SAAO,EAAE;;AAE3B,+CAA+C;AAC/C;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;AAClB;AACA,qBAAqB,WAAW,EAAE,YAAY,EAAE,eAAe,EAAE;AACjE,qBAAqB,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE;AACpE,qBAAqB,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE;;AAEpE,iFAAiF;AACjF;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,wBAAwB;EACxB;+DAC6D;EAC7D,sBAAsB;EACtB,6CAA6C;EAC7C,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,wCAAwC;AAC1C;AACA,4BAA4B,mBAAmB,EAAE;AACjD,uBAAuB,gCAAgC,EAAE;AACzD,sBAAsB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,YAAY,EAAE;AACrF;EACE,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;AACxB;AACA,sBAAsB,uBAAuB,EAAE,qBAAqB,EAAE;AACtE;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,wBAAwB;EACxB,gCAAgC;EAChC,yBAAyB;EACzB,+BAA+B;EAC/B,eAAe;EACf,wEAAwE;AAC1E;AACA,wBAAwB,2BAA2B,EAAE;AACrD;EACE,6BAA6B;EAC7B,iCAAiC;AACnC;AACA,uBAAuB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACxE;EACE,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;AACxB;AACA,sBAAsB,uBAAuB,EAAE,qBAAqB,EAAE;AACtE;EACE,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,2EAA2E;AAC3E;EACE,gCAAgC;EAChC,yBAAyB;EACzB,+BAA+B;EAC/B,gBAAgB;EAChB,0CAA0C;AAC5C;AACA,oCAAoC,6BAA6B,EAAE,2BAA2B,EAAE;;AAEhG;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,6BAA6B;EAC7B,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,wCAAwC;EACxC,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;AACtB;AACA,qBAAqB,kCAAkC,EAAE;;AAEzD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,SAAO;AACT;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,uCAAuC;AACzC;AACA,qDAAqD,yBAAyB,EAAE;;AAEhF;EACE,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,0CAA0C;AAC5C;;AAEA,uBAAuB;AACvB,oBAAoB,aAAa,EAAE,qBAAqB,EAAE,eAAe,EAAE;AAC3E;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,iCAAiC;EACjC,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,wEAAwE;AAC1E;AACA,yBAAyB,gCAAgC,EAAE;AAC3D;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,0CAA0C;EAC1C,6CAA6C;EAC7C,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,oBAAoB;EACpB,uBAAuB;AACzB;AACA,uBAAuB,qBAAqB,EAAE;AAC9C;EACE,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,wBAAwB;EACxB,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,2BAA2B;EAC3B,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,wCAAwC;AACxC;EACE,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;;kCAGkC;AAClC;EACE,4FAA4F;EAC5F,uCAAuC;AACzC;AACA,8BAA8B,qBAAqB,EAAE;;AAErD;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mGAAmG;EACnG,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,gDAAgD;AAClD;AACA,qCAAqC,0BAA0B,EAAE;;AAEjE;gEACgE;AAChE;EACE,sBAAsB;EACtB,oBAAoB;EACpB,oBAAoB;EACpB,wBAAwB;EACxB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;;;4EAG4E;AAC5E;EACE,sCAAsC;EACtC,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;AACZ;;AAEA,yEAAyE;AACzE;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;oCACoC,sBAAsB,EAAE;AAC5D,yCAAyC,kCAAkC,EAAE;AAC7E;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,UAAU;EACV,WAAW;EACX,iCAAiC;EACjC,gCAAgC;EAChC,qBAAqB;EACrB,iEAAiE;AACnE;AACA,iBAAiB,2BAA2B,EAAE,WAAW,EAAE;;AAE3D,gEAAgE;AAChE,wBAAwB,kBAAkB,EAAE,2BAA2B,EAAE;AACzE;EACE,cAAc;EACd,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,+BAA+B;AACjC;AACA;EACE,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,gDAAgD;EAChD,qBAAqB;AACvB;AACA,6DAA6D;AAC7D;EACE,aAAa;EACb,qBAAqB;EACrB,gBAAgB;EAChB,6BAA6B;EAC7B,iCAAiC;EACjC,qBAAqB;EACrB,mBAAmB;AACrB;AACA,yCAAyC,aAAa,EAAE;AACxD;EACE,cAAc;EACd,wBAAwB;AAC1B;AACA;EACE,gCAAgC;EAChC,YAAY;EACZ,+BAA+B;EAC/B,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,qEAAqE;AACvE;AACA,wBAAwB,iCAAiC,EAAE;AAC3D,yBAAyB,0BAA0B,EAAE;AACrD;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,2BAA2B;EAC3B,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,QAAQ;EACR,gCAAgC;EAChC,YAAY;EACZ,iCAAiC;AACnC;AACA;EACE,SAAO;EACP,uBAAuB;EACvB,YAAY;EACZ,6BAA6B;EAC7B,iCAAiC;EACjC,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,+FAA+F;AACjG;AACA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA,sEAAsE;AACtE;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,yCAAyC;EACzC,gCAAgC;EAChC,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,wBAAwB;EACxB,6CAA6C;AAC/C;AACA,wBAAwB,mBAAmB,EAAE;AAC7C,kBAAkB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,YAAY,EAAE;AACjF;EACE,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;AACA,yBAAyB,sBAAsB,EAAE;;AAEjD,gDAAgD;AAChD;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,4BAA4B;EAC5B,sCAAsC;EACtC,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,SAAS;EACT,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,aAAa;EACb,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":["/*\n * BeHuman Design System tokens for IVA.\n * Source: /Users/JLee/Documents/Figma TD Test (BeHuman-DesignSystem + DESIGN.md)\n *\n * Strategy:\n * - Brand colors override the existing --td-green family (the BeHuman refresh\n *   IS the brand change).\n * - New semantic colors (red/amber/blue/teal) and BeHuman scales for type,\n *   spacing, radius, shadow are added as additive tokens.\n * - The original IVA fluid type scale (--font-2xs .. --font-3xl) is left\n *   intact in App.css; new --bh-* type tokens sit alongside.\n */\n\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');\n\n/* ── TD Sans Headline (WOFF2) — display / heading typeface ──────────── */\n@font-face {\n  font-family: 'TD Sans Headline';\n  src: url('../fonts/TDSansHeadline-Light.woff2') format('woff2');\n  font-weight: 300;\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'TD Sans Headline';\n  src: url('../fonts/TDSansHeadline-LightItalic.woff2') format('woff2');\n  font-weight: 300;\n  font-style: italic;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'TD Sans Headline';\n  src: url('../fonts/TDSansHeadline-Regular.woff2') format('woff2');\n  font-weight: 400;\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'TD Sans Headline';\n  src: url('../fonts/TDSansHeadline-Italic.woff2') format('woff2');\n  font-weight: 400;\n  font-style: italic;\n  font-display: swap;\n}\n/* Bold mapped to the 700–900 range — TD Sans Headline ships only one\n   \"Bold\" cut, so 700 and 800 both render from the same file (no\n   synthetic boldening). The BeHuman type scale uses 700/800. */\n@font-face {\n  font-family: 'TD Sans Headline';\n  src: url('../fonts/TDSansHeadline-Bold.woff2') format('woff2');\n  font-weight: 700 900;\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'TD Sans Headline';\n  src: url('../fonts/TDSansHeadline-BoldItalic.woff2') format('woff2');\n  font-weight: 700 900;\n  font-style: italic;\n  font-display: swap;\n}\n\n/* ── TD Graphik (OTF) — body / UI typeface ──────────────────────────── */\n@font-face {\n  font-family: 'TD Graphik';\n  src: url('../fonts/TD Graphik-Semilight.otf') format('opentype');\n  font-weight: 300;\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'TD Graphik';\n  src: url('../fonts/TD Graphik-Semilight Italic.otf') format('opentype');\n  font-weight: 300;\n  font-style: italic;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'TD Graphik';\n  src: url('../fonts/TD Graphik-Regular.otf') format('opentype');\n  font-weight: 400;\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'TD Graphik';\n  src: url('../fonts/TD Graphik-Regular Italic.otf') format('opentype');\n  font-weight: 400;\n  font-style: italic;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'TD Graphik';\n  src: url('../fonts/TD Graphik-Medium.otf') format('opentype');\n  font-weight: 500;\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'TD Graphik';\n  src: url('../fonts/TD Graphik-Medium Italic.otf') format('opentype');\n  font-weight: 500;\n  font-style: italic;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'TD Graphik';\n  src: url('../fonts/TD Graphik-Semibold.otf') format('opentype');\n  font-weight: 600;\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'TD Graphik';\n  src: url('../fonts/TD Graphik-Semibold Italic.otf') format('opentype');\n  font-weight: 600;\n  font-style: italic;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'TD Graphik';\n  src: url('../fonts/TD Graphik-Bold.otf') format('opentype');\n  font-weight: 700;\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'TD Graphik';\n  src: url('../fonts/TD Graphik-Bold Italic.otf') format('opentype');\n  font-weight: 700;\n  font-style: italic;\n  font-display: swap;\n}\n\n:root {\n  /* ── Brand: TD shield green (BeHuman) ──────────────────────────────── */\n  --td-green: #2FBF00;\n  --td-dark-green: #259900;\n  --td-green-dark: #259900;       /* alias used by some BeHuman snippets */\n  --td-green-light: #E6F9E0;\n  --td-accent: #2FBF00;           /* keep IVA name, point at brand green */\n\n  /* ── Button-specific palette (May 2026 update) ────────────────────────\n     Buttons use a slightly different green from the brand fill so they\n     pop against the green-tinted hero gradients and balance cards. */\n  --btn-primary:           #42BF19;   /* primary button fill */\n  --btn-primary-hover:     #36A015;   /* primary on hover/press */\n  --btn-primary-alt:       #002B1A;   /* primary alt — Premium Green fill */\n  --btn-primary-alt-hover: #001A0F;\n  --btn-secondary-outline: #002B1A;   /* secondary — Premium Green stroke */\n  --btn-destructive:       #AE1100;   /* destructive primary — brick */\n  --btn-destructive-hover: #8E0E00;\n\n  /* ── Neutrals ──────────────────────────────────────────────────────── */\n  --bh-black: #000000;\n  --bh-dark: #333333;\n  --bh-gray: #666666;\n  --bh-light-gray: #F5F5F5;\n  --bh-white: #FFFFFF;\n\n  /* ── Semantic ──────────────────────────────────────────────────────── */\n  --td-red: #D32F2F;\n  --td-amber: #F59E0B;\n  --td-blue: #2563EB;\n  --td-teal: #448889;     /* BeHuman accent teal */\n\n  /* ── Accent palette — for charts, categories, secondary indicators ── */\n  --td-premium:   #002B1A;   /* Premium dark green — VIP / wealth tier */\n  --td-shield:    #2FBF00;   /* Shield Green — alias of --td-green */\n  --td-gold:      #CFBD91;\n  --td-brown:     #7C5636;\n  --td-tan:       #D9BFAF;\n  --td-lavender:  #946E9F;\n  --td-purple:    #462992;\n\n  /* ── Soft accent pairs (May 2026) — saturated + pale companion.\n     Use saturated for icons/borders/badges, soft for backgrounds. ── */\n  --td-yellow:      #FEEF60;\n  --td-yellow-soft: #FFF9BF;\n  --td-pink:        #FEBFDA;\n  --td-pink-soft:   #FFE5F0;\n  --td-sky:         #A4D6DD;\n  --td-sky-soft:    #DBEFF1;\n\n  /* Chart palette (May 2026 refresh) — pastels-first, anchored on brand\n     green + premium dark. Slots are ordered for default categorical data\n     series; use --td-chart-1 first, then --td-chart-2, etc. */\n  --td-chart-1: var(--td-shield);  /* primary brand */\n  --td-chart-2: var(--td-sky);     /* pastel cool */\n  --td-chart-3: var(--td-pink);    /* pastel warm */\n  --td-chart-4: var(--td-yellow);  /* pastel bright */\n  --td-chart-5: var(--td-teal);    /* deeper cool */\n  --td-chart-6: var(--td-premium); /* anchor / \"other\" */\n  /* Slots 7-8 only used by charts with >6 categories. Keep two\n     off-brand hues for tail-end series so adjacent slices still differ. */\n  --td-chart-7: var(--td-lavender);\n  --td-chart-8: var(--td-gold);\n\n  /* ── Typography ────────────────────────────────────────────────────── */\n  --bh-font-heading: 'TD Sans Headline', 'Neue Haas Grotesk Display', 'Inter', 'SF Pro Display', system-ui, sans-serif;\n  --bh-font-body:    'TD Graphik', 'Graphik', 'Inter', 'SF Pro Text', system-ui, sans-serif;\n  --bh-font-mono:    'SF Mono', 'Menlo', monospace;\n\n  /* BeHuman type scale — bolder than IVA's, used on refreshed screens.\n     Existing screens keep using --font-* (clamp-based) until migrated. */\n  --bh-display:  800 3rem/1.1     var(--bh-font-heading);\n  --bh-h1:       800 2.25rem/1.2  var(--bh-font-heading);\n  --bh-h2:       700 1.75rem/1.3  var(--bh-font-heading);\n  --bh-h3:       700 1.375rem/1.4 var(--bh-font-heading);\n  --bh-body-lg:  400 1.125rem/1.5 var(--bh-font-body);\n  --bh-body:     400 1rem/1.5     var(--bh-font-body);\n  --bh-body-sm:  400 0.875rem/1.4 var(--bh-font-body);\n  --bh-caption:  400 0.75rem/1.3  var(--bh-font-body);\n  --bh-overline: 600 0.6875rem/1.4 var(--bh-font-body);\n\n  /* ── Spacing (8px baseline) ────────────────────────────────────────── */\n  --space-3xs: 0.25rem;\n  --space-2xs: 0.5rem;\n  --space-xs:  0.75rem;\n  --space-sm:  1rem;\n  --space-md:  1.5rem;\n  --space-lg:  2rem;\n  --space-xl:  3rem;\n  --space-2xl: 4rem;\n  --space-3xl: 6rem;\n\n  /* ── Radius ────────────────────────────────────────────────────────────\n     Updated per BeHuman guideline (May 2026): sharp by default, BUT specific\n     categories may have rounded corners. See styles/Guidelines.md for the\n     full rules. Quick reference:\n       Rounded → buttons, input fields, checkboxes, cards, tab items\n       Sharp   → component surfaces, navigation items, dividers, holding\n                 shapes, image containers\n     The tokens below carry sensible rounded values so bh-* primitives that\n     opt in (cards, buttons, inputs, etc.) get the right look automatically.\n     Surfaces/nav/images explicitly set border-radius: 0 in App.css. */\n  --radius-sm:   0.25rem;   /* 4px — small elements, badges */\n  --radius-md:   0.5rem;    /* 8px — buttons, inputs, checkboxes, tabs */\n  --radius-lg:   0.75rem;   /* 12px — cards */\n  --radius-xl:   1rem;      /* 16px — large cards / containers */\n  --radius-full: 9999px;    /* pills, avatars (when intentionally circular) */\n\n  /* ── Shadows ───────────────────────────────────────────────────────── */\n  --shadow-sm:    0 1px 2px rgba(0,0,0,0.05);\n  --shadow-md:    0 1px 3px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.06);\n  --shadow-lg:    0 3px 6px rgba(0,0,0,0.10), 0 2px 4px rgba(0,0,0,0.06);\n  --shadow-xl:    0 10px 15px rgba(0,0,0,0.10), 0 4px 6px rgba(0,0,0,0.05);\n  --shadow-green: 0 4px 14px rgba(47, 191, 0, 0.25);\n}\n\n/* ── Reusable BeHuman component primitives ──────────────────────────── */\n\n.bh-btn-primary {\n  background: var(--btn-primary);\n  color: var(--bh-black);\n  border: none;\n  border-radius: var(--radius-md);\n  padding: 12px 24px;\n  font: var(--bh-body);\n  font-weight: 700;\n  min-height: 44px;\n  cursor: pointer;\n  transition: background 200ms ease-in-out, box-shadow 200ms ease-in-out, transform 200ms ease-in-out;\n}\n.bh-btn-primary:hover:not(:disabled) {\n  background: var(--btn-primary-hover);\n  box-shadow: var(--shadow-green);\n}\n.bh-btn-primary:active:not(:disabled) { transform: translateY(1px); }\n.bh-btn-primary:disabled { opacity: 0.6; cursor: not-allowed; }\n\n/* Primary alt — same shape as primary, Premium Green fill, white text. */\n.bh-btn-primary-alt {\n  background: var(--btn-primary-alt);\n  color: var(--bh-white);\n  border: none;\n  border-radius: var(--radius-md);\n  padding: 12px 24px;\n  font: var(--bh-body);\n  font-weight: 700;\n  min-height: 44px;\n  cursor: pointer;\n  transition: background 200ms ease-in-out, box-shadow 200ms ease-in-out, transform 200ms ease-in-out;\n}\n.bh-btn-primary-alt:hover:not(:disabled) { background: var(--btn-primary-alt-hover); }\n.bh-btn-primary-alt:active:not(:disabled) { transform: translateY(1px); }\n.bh-btn-primary-alt:disabled { opacity: 0.6; cursor: not-allowed; }\n\n/* Secondary — blank fill, Premium Green stroke. */\n.bh-btn-secondary {\n  background: transparent;\n  color: var(--btn-secondary-outline);\n  border: 1.5px solid var(--btn-secondary-outline);\n  border-radius: var(--radius-md);\n  padding: 10.5px 22.5px;\n  font: var(--bh-body);\n  font-weight: 700;\n  min-height: 44px;\n  cursor: pointer;\n  transition: background 200ms ease-in-out, color 200ms ease-in-out;\n}\n.bh-btn-secondary:hover:not(:disabled) {\n  background: var(--btn-primary-alt);\n  color: var(--bh-white);\n}\n\n/* Destructive primary — brick fill, white text. Use for irreversible\n   actions: delete, cancel-and-discard, freeze-card, report fraud. */\n.bh-btn-destructive {\n  background: var(--btn-destructive);\n  color: var(--bh-white);\n  border: none;\n  border-radius: var(--radius-md);\n  padding: 12px 24px;\n  font: var(--bh-body);\n  font-weight: 700;\n  min-height: 44px;\n  cursor: pointer;\n  transition: background 200ms ease-in-out, box-shadow 200ms ease-in-out, transform 200ms ease-in-out;\n}\n.bh-btn-destructive:hover:not(:disabled) {\n  background: var(--btn-destructive-hover);\n  box-shadow: 0 4px 14px rgba(174, 17, 0, 0.25);\n}\n.bh-btn-destructive:active:not(:disabled) { transform: translateY(1px); }\n.bh-btn-destructive:disabled { opacity: 0.6; cursor: not-allowed; }\n\n.bh-input {\n  box-sizing: border-box;\n  width: 100%;\n  height: 44px;\n  border: 1px solid var(--bh-light-gray);\n  border-radius: var(--radius-md);\n  padding: 0 16px;\n  font: var(--bh-body);\n  color: var(--bh-black);\n  background: var(--bh-white);\n  outline: none;\n  transition: border-color 200ms ease-in-out, box-shadow 200ms ease-in-out;\n}\n.bh-input::placeholder { color: var(--bh-gray); font-weight: 400; }\n.bh-input:focus {\n  border-color: var(--td-green);\n  box-shadow: 0 0 0 3px var(--td-green-light);\n}\n\n.bh-card {\n  background: var(--bh-white);\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--bh-light-gray);\n  padding: var(--space-md);\n  box-shadow: var(--shadow-md);\n  transition: box-shadow 200ms ease-in-out, transform 200ms ease-in-out;\n}\n.bh-card:hover { box-shadow: var(--shadow-lg); }\n\n/* ── BeHuman Home (Banking-screen pattern) ────────────────────────── */\n\n.bh-home { background: var(--bh-light-gray); }\n.bh-home .bh-home-main {\n  padding: var(--space-md) 0 var(--space-lg);\n}\n\n.bh-home-topbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--space-xs) var(--space-sm);\n  background: var(--bh-white);\n}\n.bh-home-logo { height: 22px; width: auto; opacity: 0.95; }\n.bh-icon-btn {\n  background: transparent;\n  border: none;\n  color: var(--bh-black);\n  font-size: var(--font-xl);\n  width: 40px;\n  height: 40px;\n  border-radius: var(--radius-full);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background-color 200ms ease-in-out;\n}\n.bh-icon-btn:hover { background: var(--bh-light-gray); }\n\n/* Badged variant — shows the value of data-badge as a small red pill at\n   the top-right of the icon. Hide when data-badge is \"0\" or empty. */\n.bh-icon-btn--badged { position: relative; }\n.bh-icon-btn--badged[data-badge]:not([data-badge=\"0\"]):not([data-badge=\"\"])::after {\n  content: attr(data-badge);\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  min-width: 16px;\n  height: 16px;\n  padding: 0 4px;\n  background: var(--td-red);\n  color: var(--bh-white);\n  font: var(--bh-caption);\n  font-weight: 700;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--radius-full);\n  pointer-events: none;\n}\n\n.bh-home-banner-wrapper {\n  background: var(--bh-white);\n  padding: 0 var(--space-sm) var(--space-2xs);\n}\n\n.bh-balance-hero {\n  background: linear-gradient(180deg, var(--td-green) 0%, var(--td-dark-green) 100%);\n  color: var(--bh-white);\n  padding: var(--space-md);\n  border-bottom-left-radius: var(--radius-xl);\n  border-bottom-right-radius: var(--radius-xl);\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-md);\n}\n.bh-balance-hero-greeting { display: flex; flex-direction: column; }\n.bh-balance-hero-eyebrow {\n  margin: 0 0 var(--space-3xs);\n  font: var(--bh-body-sm);\n  opacity: 0.85;\n}\n.bh-balance-hero-name {\n  margin: 0;\n  font: var(--bh-h1);\n  letter-spacing: -0.01em;\n}\n\n.bh-balance-card {\n  background: var(--bh-black);\n  color: var(--bh-white);\n  border-radius: var(--radius-lg);\n  padding: var(--space-md);\n}\n.bh-balance-card-label {\n  margin: 0 0 var(--space-2xs);\n  font: var(--bh-body-sm);\n  opacity: 0.8;\n}\n.bh-balance-card-amount {\n  margin: 0;\n  font: var(--bh-display);\n  letter-spacing: -0.02em;\n}\n\n.bh-section { padding: 0 var(--space-md); margin-top: var(--space-md); }\n.bh-section:first-child { margin-top: 0; }\n.bh-section-title {\n  margin: 0 0 var(--space-sm);\n  font: var(--bh-overline);\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--text-dark); /* themed: charcoal on light, cream on dark — sits on the screen bg, not a card */\n}\n\n.bh-qa-grid {\n  display: flex;\n  gap: var(--space-2xs);\n  overflow-x: auto;\n  scroll-snap-type: x mandatory;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n  /* bleed past section padding so cards reach the edge */\n  margin-left: calc(-1 * var(--space-md));\n  margin-right: calc(-1 * var(--space-md));\n  padding-left: var(--space-md);\n  padding-right: var(--space-md);\n  padding-bottom: 4px;\n}\n.bh-qa-grid::-webkit-scrollbar { display: none; }\n.bh-qa-grid .bh-qa-card {\n  flex: 0 0 80px;\n  scroll-snap-align: start;\n}\n.bh-qa-card {\n  background: var(--bh-white);\n  border: 1px solid var(--bh-light-gray);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-sm);\n  padding: var(--space-sm) var(--space-2xs);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--space-2xs);\n  font: var(--bh-caption);\n  color: var(--bh-dark);\n  cursor: pointer;\n  transition: box-shadow 200ms ease-in-out, transform 200ms ease-in-out;\n}\n.bh-qa-card:hover { box-shadow: var(--shadow-md); }\n.bh-qa-card:active { transform: translateY(1px); }\n.bh-qa-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: var(--radius-full);\n  background: var(--td-green);\n  color: var(--bh-black);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: var(--font-lg);\n}\n\n.bh-account-list {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2xs);\n}\n.bh-account-card {\n  background: var(--bh-white);\n  border: 1px solid var(--bh-light-gray);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-sm);\n  padding: var(--space-sm);\n  text-align: left;\n  cursor: pointer;\n  transition: box-shadow 200ms ease-in-out, transform 200ms ease-in-out;\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3xs);\n  width: 100%;\n}\n.bh-account-card:hover { box-shadow: var(--shadow-md); }\n.bh-account-card-type {\n  margin: 0;\n  font: var(--bh-caption);\n  color: var(--bh-gray);\n}\n.bh-account-card-balance {\n  margin: 0;\n  font: var(--bh-h2);\n  color: var(--bh-black);\n  letter-spacing: -0.01em;\n}\n.bh-account-card-balance.is-debt { color: var(--td-red); }\n.bh-account-card-number {\n  margin: 0;\n  font: var(--bh-caption);\n  color: var(--bh-gray);\n}\n\n/* ── BeHuman flow screens (e-Transfer pattern) ─────────────────────── */\n\n.bh-flow {\n  background: var(--bh-light-gray);\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n}\n\n/* Green hero header — kit uses BLACK title on green for transactional flows.\n   flex-shrink: 0 so the hero locks at its natural height and the\n   .bh-flow-body below claims the remaining space for scroll. */\n.bh-flow-hero {\n  background: linear-gradient(135deg, var(--td-green) 0%, var(--td-dark-green) 100%);\n  padding: var(--space-md) var(--space-md) var(--space-2xl);\n  display: flex;\n  align-items: center;\n  gap: var(--space-2xs);\n  color: var(--bh-black);\n  justify-content: space-between;\n  flex-shrink: 0;\n}\n.bh-flow-hero-left {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2xs);\n  min-width: 0;\n  flex: 1;\n}\n.bh-flow-back {\n  background: transparent;\n  border: none;\n  width: 40px;\n  height: 40px;\n  border-radius: var(--radius-full);\n  color: var(--bh-black);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 26px;\n  transition: background-color 200ms ease-in-out;\n}\n.bh-flow-back:hover { background: rgba(0,0,0,0.08); }\n.bh-flow-title {\n  margin: 0;\n  font: var(--bh-h2);\n  letter-spacing: -0.01em;\n  color: var(--bh-black);\n}\n\n/* Form/content area lifts up over the hero for the \"stacked card\" feel.\n   min-height: 0 + flex: 1 lets the body claim the remaining vertical space\n   and scroll its own content (transaction lists, long forms). A thin\n   gray scrollbar makes the scroll affordance visible — earlier we hid it\n   for cleanliness, but users couldn't tell they could scroll. */\n.bh-flow-body {\n  margin-top: calc(-1 * var(--space-md));\n  padding: 0 var(--space-md) var(--space-lg);\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-md);\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(0, 0, 0, 0.18) transparent;\n}\n/* The body is a scrolling flex column, so its cards must keep their natural\n   height and let the body scroll — never shrink to fit. Without this, a card\n   with `overflow:hidden` (whose flex auto-min-height collapses to 0) gets\n   squeezed and clips its own content (e.g. the Rewards points hero). Inline\n   `flex` on a child still wins, so intentional grow/shrink is unaffected. */\n.bh-flow-body > * { flex-shrink: 0; }\n.bh-flow-body::-webkit-scrollbar { width: 6px; }\n.bh-flow-body::-webkit-scrollbar-track { background: transparent; }\n.bh-flow-body::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.18);\n  border-radius: 0;\n}\n.bh-flow-body::-webkit-scrollbar-thumb:hover { background: rgba(0, 0, 0, 0.32); }\n\n.bh-form-card {\n  background: var(--bh-white);\n  border-radius: var(--radius-xl);\n  box-shadow: var(--shadow-md);\n  padding: var(--space-md);\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-sm);\n}\n.bh-form-card-title {\n  margin: 0 0 var(--space-2xs);\n  font: var(--bh-h3);\n  color: var(--bh-black);\n}\n\n.bh-field { display: flex; flex-direction: column; gap: var(--space-3xs); }\n.bh-field-label {\n  font: var(--bh-body-sm);\n  font-weight: 600;\n  color: var(--bh-black);\n  display: inline-flex;\n  align-items: center;\n  gap: var(--space-3xs);\n}\n.bh-field-input,\n.bh-field-textarea,\n.bh-field-select {\n  width: 100%;\n  background: var(--bh-light-gray);\n  border: 2px solid #E5E7EB;\n  border-radius: var(--radius-md);\n  padding: 12px 16px;\n  font: var(--bh-body);\n  color: var(--bh-black);\n  outline: none;\n  transition: border-color 200ms ease-in-out, background 200ms ease-in-out;\n  appearance: none;\n  -webkit-appearance: none;\n}\n.bh-field-input:focus,\n.bh-field-textarea:focus,\n.bh-field-select:focus {\n  border-color: var(--td-green);\n  background: var(--bh-white);\n}\n.bh-field-input.is-error,\n.bh-field-textarea.is-error,\n.bh-field-select.is-error { border-color: var(--td-red); }\n.bh-field-input.is-amount {\n  font: var(--bh-h2);\n  font-weight: 700;\n  letter-spacing: -0.01em;\n}\n.bh-field-textarea { resize: vertical; min-height: 80px; }\n.bh-field-error {\n  margin-top: var(--space-3xs);\n  font: var(--bh-caption);\n  color: var(--td-red);\n}\n\n/* Buttons — kit uses BLACK text on green CTAs and BLACK fill for confirm.\n   Primary fill is var(--btn-primary) per the May 2026 button-color update. */\n.bh-btn-cta {\n  background: var(--btn-primary);\n  color: var(--bh-black);\n  border: none;\n  border-radius: var(--radius-md);\n  padding: 16px 24px;\n  width: 100%;\n  font: var(--bh-body);\n  font-weight: 700;\n  min-height: 52px;\n  cursor: pointer;\n  transition: background 200ms ease-in-out, box-shadow 200ms ease-in-out, transform 200ms ease-in-out;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-2xs);\n}\n.bh-btn-cta:hover:not(:disabled) {\n  background: var(--btn-primary-hover);\n  box-shadow: var(--shadow-green);\n}\n.bh-btn-cta:active:not(:disabled) { transform: translateY(1px); }\n.bh-btn-cta:disabled { opacity: 0.55; cursor: not-allowed; }\n\n.bh-btn-dark {\n  background: var(--bh-black);\n  color: var(--bh-white);\n  border: none;\n  border-radius: var(--radius-md);\n  padding: 14px 20px;\n  font: var(--bh-body);\n  font-weight: 700;\n  min-height: 48px;\n  cursor: pointer;\n  transition: background 200ms ease-in-out, transform 200ms ease-in-out;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-2xs);\n}\n.bh-btn-dark:hover:not(:disabled) { background: #1a1a1a; }\n.bh-btn-dark:active:not(:disabled) { transform: translateY(1px); }\n\n.bh-btn-outline-dark {\n  background: var(--bh-white);\n  color: var(--bh-black);\n  border: 2px solid var(--bh-black);\n  border-radius: var(--radius-md);\n  padding: 12px 20px;\n  font: var(--bh-body);\n  font-weight: 700;\n  min-height: 48px;\n  cursor: pointer;\n  transition: background 200ms ease-in-out;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-2xs);\n}\n.bh-btn-outline-dark:hover { background: var(--bh-light-gray); }\n\n.bh-btn-row { display: flex; gap: var(--space-2xs); }\n.bh-btn-row > * { flex: 1; }\n\n/* Avatar circle — green fill, BLACK initials */\n.bh-avatar {\n  border-radius: var(--radius-full);\n  background: var(--td-green);\n  color: var(--bh-black);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font: var(--bh-body);\n  font-weight: 700;\n}\n.bh-avatar.size-md { width: 48px; height: 48px; font-size: 1rem; }\n.bh-avatar.size-lg { width: 64px; height: 64px; font-size: 1.25rem; }\n.bh-avatar.size-xl { width: 88px; height: 88px; font-size: 1.75rem; }\n\n/* Recent transfers list — single white card, rows with hairlines (kit pattern) */\n.bh-recent-list {\n  background: var(--bh-white);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-sm);\n  overflow: hidden;\n}\n.bh-recent-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: var(--space-sm);\n  padding: var(--space-sm);\n  /* width:100% + padding must include the padding, or the row overflows its\n     (overflow:hidden) list and clips the right-side amounts. */\n  box-sizing: border-box;\n  border-bottom: 1px solid var(--bh-light-gray);\n  cursor: pointer;\n  background: transparent;\n  border-left: none;\n  border-right: none;\n  border-top: none;\n  width: 100%;\n  text-align: left;\n  transition: background 200ms ease-in-out;\n}\n.bh-recent-row:last-child { border-bottom: none; }\n.bh-recent-row:hover { background: var(--bh-light-gray); }\n.bh-recent-row-info { display: flex; flex-direction: column; gap: 2px; min-width: 0; }\n.bh-recent-row-name {\n  font: var(--bh-body-sm);\n  font-weight: 600;\n  color: var(--bh-black);\n}\n.bh-recent-row-date { font: var(--bh-caption); color: var(--bh-gray); }\n.bh-recent-row-meta {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 2px;\n  flex-shrink: 0;\n}\n.bh-recent-row-amount {\n  font: var(--bh-body-sm);\n  font-weight: 700;\n  color: var(--bh-black);\n}\n.bh-recent-row-status {\n  font: var(--bh-caption);\n  color: var(--td-green);\n}\n\n/* Account radio rows inside a form card */\n.bh-account-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--space-sm);\n  background: var(--bh-light-gray);\n  border: 2px solid #E5E7EB;\n  border-radius: var(--radius-md);\n  cursor: pointer;\n  transition: border-color 200ms ease-in-out, background 200ms ease-in-out;\n}\n.bh-account-row:hover { background: var(--bh-white); }\n.bh-account-row.selected {\n  border-color: var(--td-green);\n  background: var(--td-green-light);\n}\n.bh-account-row-info { display: flex; flex-direction: column; gap: 2px; }\n.bh-account-row-name {\n  font: var(--bh-body);\n  font-weight: 600;\n  color: var(--bh-black);\n}\n.bh-account-row-num { font: var(--bh-caption); color: var(--bh-gray); }\n.bh-account-row-balance {\n  font: var(--bh-body);\n  font-weight: 700;\n  color: var(--bh-black);\n}\n\n/* 2-line account picker (used where a single-line <select> wouldn't fit) */\n.bh-acct-picker {\n  background: var(--bh-light-gray);\n  border: 2px solid #E5E7EB;\n  border-radius: var(--radius-md);\n  overflow: hidden;\n  transition: border-color 200ms ease-in-out;\n}\n.bh-acct-picker[data-open=\"true\"] { border-color: var(--td-green); background: var(--bh-white); }\n\n.bh-acct-row {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-sm);\n  padding: 10px var(--space-sm);\n  background: transparent;\n  border: none;\n  text-align: left;\n  cursor: pointer;\n  transition: background 200ms ease-in-out;\n  min-height: auto;\n  color: var(--bh-black);\n  font: var(--bh-body);\n}\n.bh-acct-row:hover { background: rgba(47, 191, 0, 0.06); }\n\n.bh-acct-row-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n  flex: 1;\n}\n.bh-acct-row-name {\n  font: var(--bh-body);\n  font-weight: 600;\n  color: var(--bh-black);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.bh-acct-row-meta {\n  display: flex;\n  justify-content: space-between;\n  gap: var(--space-2xs);\n  font: var(--bh-caption);\n  color: var(--bh-gray);\n}\n.bh-acct-row-meta > span:last-child {\n  color: var(--bh-black);\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.bh-acct-chevron {\n  flex-shrink: 0;\n  color: var(--bh-dark);\n  transition: transform 200ms ease-in-out;\n}\n.bh-acct-picker[data-open=\"true\"] .bh-acct-chevron { transform: rotate(180deg); }\n\n.bh-acct-options {\n  border-top: 1px solid var(--bh-light-gray);\n  display: flex;\n  flex-direction: column;\n}\n.bh-acct-options .bh-acct-row + .bh-acct-row {\n  border-top: 1px solid var(--bh-light-gray);\n}\n\n/* Quick amount chips */\n.bh-quick-amounts { display: flex; gap: var(--space-2xs); flex-wrap: wrap; }\n.bh-quick-amount {\n  background: var(--bh-white);\n  border: 2px solid #E5E7EB;\n  border-radius: var(--radius-full);\n  padding: 8px 16px;\n  font: var(--bh-body-sm);\n  font-weight: 600;\n  color: var(--bh-black);\n  cursor: pointer;\n  transition: background 200ms ease-in-out, border-color 200ms ease-in-out;\n}\n.bh-quick-amount:hover { background: var(--bh-light-gray); }\n.bh-quick-amount.selected {\n  background: var(--td-green);\n  border-color: var(--td-green);\n}\n\n/* Review rows */\n.bh-review-rows {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2xs);\n  border-top: 1px solid var(--bh-light-gray);\n  border-bottom: 1px solid var(--bh-light-gray);\n  padding: var(--space-sm) 0;\n}\n.bh-review-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: var(--space-sm);\n  font: var(--bh-body-sm);\n}\n.bh-review-row-label { color: var(--bh-gray); }\n.bh-review-row-value {\n  font-weight: 600;\n  color: var(--bh-black);\n  text-align: right;\n}\n\n.bh-info-box {\n  background: var(--bh-light-gray);\n  border-radius: var(--radius-md);\n  padding: var(--space-sm);\n  font: var(--bh-caption);\n  color: var(--bh-gray);\n  line-height: 1.5;\n}\n\n/* Success state */\n.bh-success-icon {\n  width: 80px;\n  height: 80px;\n  border-radius: var(--radius-full);\n  background: var(--td-green);\n  color: var(--bh-black);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto;\n}\n.bh-success-title {\n  margin: 0;\n  font: var(--bh-h2);\n  text-align: center;\n  color: var(--bh-black);\n}\n.bh-success-subtitle {\n  margin: 0;\n  font: var(--bh-body);\n  text-align: center;\n  color: var(--bh-gray);\n}\n\n/* Big amount display (review/success) */\n.bh-amount-display {\n  margin: 0;\n  font: var(--bh-display);\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  color: var(--td-green);\n  text-align: center;\n}\n\n/* ── High-net-worth premium theme (Investing screen) ───────────────────\n   Black + gold dual-tone — used on .port-screen for the wealth\n   management aesthetic. Avoids the bright shield-green; gold replaces\n   green as the positive accent. */\n.port-screen .bh-flow-hero.dark {\n  background: linear-gradient(135deg, var(--td-premium) 0%, var(--bh-black) 70%, #1a1a1a 100%);\n  border-bottom: 1px solid var(--td-gold);\n}\n.port-screen .bh-flow-title { color: var(--td-gold); }\n\n.bh-btn-gold {\n  background: var(--td-gold);\n  color: var(--bh-black);\n  border: none;\n  padding: 14px 24px;\n  width: 100%;\n  font: var(--bh-body);\n  font-weight: 700;\n  min-height: 52px;\n  cursor: pointer;\n  transition: background 200ms ease-in-out, box-shadow 200ms ease-in-out, transform 200ms ease-in-out;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-2xs);\n}\n.bh-btn-gold:hover:not(:disabled) {\n  background: #BBA77B;\n  box-shadow: 0 4px 14px rgba(207, 189, 145, 0.35);\n}\n.bh-btn-gold:active:not(:disabled) { transform: translateY(1px); }\n\n/* Tall hero — fits a balance card (and optionally an action card) under\n   the title row. flex-shrink: 0 inherited from .bh-flow-hero. */\n.bh-flow-hero.tall {\n  flex-direction: column;\n  align-items: stretch;\n  gap: var(--space-md);\n  padding: var(--space-md);\n  padding-bottom: var(--space-2xl);\n}\n.bh-flow-hero.tall .bh-flow-hero-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-2xs);\n}\n\n/* AccountDetailsScreen single-scroll layout: hero + balance + actions +\n   tabs + transactions all scroll together inside .scroll-content. The\n   content lifts up over the green hero the same way .bh-flow-body does,\n   but is otherwise a plain block stack (no flex split, no overflow trap). */\n.account-details-content {\n  margin-top: calc(-1 * var(--space-md));\n  padding: 0 var(--space-md) var(--space-lg);\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-md);\n  position: relative;\n  z-index: 1;\n}\n\n/* Dark hero variant — used for non-transactional account/product pages */\n.bh-flow-hero.dark {\n  background: var(--bh-black);\n  color: var(--bh-white);\n}\n.bh-flow-hero.dark .bh-flow-back,\n.bh-flow-hero.dark .bh-flow-title { color: var(--bh-white); }\n.bh-flow-hero.dark .bh-flow-back:hover { background: rgba(255,255,255,0.12); }\n.bh-flow-hero-subtitle {\n  margin: var(--space-3xs) 0 0;\n  font: var(--bh-body-sm);\n  opacity: 0.85;\n}\n\n/* Pagination dots */\n.bh-dots {\n  display: flex;\n  gap: 6px;\n  justify-content: center;\n  padding: var(--space-2xs) 0;\n}\n.bh-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: var(--radius-full);\n  background: var(--bh-light-gray);\n  display: inline-block;\n  transition: width 200ms ease-in-out, background 200ms ease-in-out;\n}\n.bh-dot.active { background: var(--td-green); width: 18px; }\n\n/* Centered balance block inside a card (eyebrow + big amount) */\n.bh-hero-card-balance { text-align: center; padding: var(--space-2xs) 0; }\n.bh-hero-card-eyebrow {\n  display: block;\n  font: var(--bh-overline);\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--bh-gray);\n  margin-bottom: var(--space-3xs);\n}\n.bh-hero-card-amount {\n  margin: 0;\n  font: var(--bh-display);\n  font-weight: 800;\n  color: var(--bh-black);\n  letter-spacing: -0.02em;\n}\n\n/* Action row (Pay/Transfer/Deposit etc.) — inside a form card */\n.bh-action-row {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: var(--space-2xs);\n}\n/* Carousel variant — horizontally scrollable, snap-to-card */\n.bh-action-carousel {\n  display: flex;\n  gap: var(--space-2xs);\n  overflow-x: auto;\n  scroll-snap-type: x mandatory;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n  padding-bottom: 2px;\n}\n.bh-action-carousel::-webkit-scrollbar { display: none; }\n.bh-action-carousel .bh-action-card {\n  flex: 0 0 72px;\n  scroll-snap-align: start;\n}\n.bh-action-card {\n  background: var(--bh-light-gray);\n  border: none;\n  border-radius: var(--radius-lg);\n  padding: var(--space-sm) var(--space-2xs);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--space-2xs);\n  cursor: pointer;\n  font: var(--bh-caption);\n  font-weight: 600;\n  color: var(--bh-black);\n  transition: background 200ms ease-in-out, transform 200ms ease-in-out;\n}\n.bh-action-card:hover { background: var(--td-green-light); }\n.bh-action-card:active { transform: translateY(1px); }\n.bh-action-card-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: var(--radius-full);\n  background: var(--td-green);\n  color: var(--bh-black);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: var(--font-lg);\n}\n\n/* Pill segmented tabs */\n.bh-tabs {\n  display: flex;\n  gap: 4px;\n  background: var(--bh-light-gray);\n  padding: 4px;\n  border-radius: var(--radius-full);\n}\n.bh-tab {\n  flex: 1;\n  background: transparent;\n  border: none;\n  padding: 10px var(--space-sm);\n  border-radius: var(--radius-full);\n  font: var(--bh-body-sm);\n  font-weight: 600;\n  color: var(--bh-gray);\n  cursor: pointer;\n  transition: background 200ms ease-in-out, color 200ms ease-in-out, box-shadow 200ms ease-in-out;\n}\n.bh-tab.active {\n  background: var(--bh-white);\n  color: var(--bh-black);\n  box-shadow: var(--shadow-sm);\n}\n\n/* Transaction list — single white card, group titles, hairline rows */\n.bh-tx-list {\n  background: var(--bh-white);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-sm);\n  overflow: hidden;\n}\n.bh-tx-group-title {\n  padding: var(--space-2xs) var(--space-sm);\n  background: var(--bh-light-gray);\n  font: var(--bh-overline);\n  text-transform: uppercase;\n  color: var(--bh-gray);\n}\n.bh-tx-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: var(--space-sm);\n  padding: var(--space-sm);\n  border-bottom: 1px solid var(--bh-light-gray);\n}\n.bh-tx-row:last-child { border-bottom: none; }\n.bh-tx-row-info { display: flex; flex-direction: column; gap: 2px; min-width: 0; }\n.bh-tx-merchant {\n  font: var(--bh-body-sm);\n  font-weight: 600;\n  color: var(--bh-black);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.bh-tx-date {\n  font: var(--bh-caption);\n  color: var(--bh-gray);\n}\n.bh-tx-amount {\n  font: var(--bh-body-sm);\n  font-weight: 700;\n  color: var(--bh-black);\n  flex-shrink: 0;\n}\n.bh-tx-amount.positive { color: var(--td-green); }\n\n/* Product card (loan/credit/savings products) */\n.bh-product-card {\n  background: var(--bh-white);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-sm);\n  border: 1px solid var(--bh-light-gray);\n  padding: var(--space-md);\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2xs);\n}\n.bh-product-card-title {\n  margin: 0;\n  font: var(--bh-h3);\n  color: var(--bh-black);\n}\n.bh-product-card-rate {\n  margin: 0;\n  font: var(--bh-h2);\n  font-weight: 800;\n  color: var(--td-green);\n  letter-spacing: -0.01em;\n}\n.bh-product-card-desc {\n  margin: 0;\n  font: var(--bh-body-sm);\n  color: var(--bh-dark);\n  line-height: 1.5;\n}\n.bh-product-card-features {\n  margin: var(--space-2xs) 0;\n  padding: 0;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3xs);\n}\n.bh-product-card-features li {\n  font: var(--bh-body-sm);\n  color: var(--bh-dark);\n  display: flex;\n  align-items: flex-start;\n  gap: var(--space-2xs);\n}\n.bh-product-card-features li::before {\n  content: '✓';\n  color: var(--td-green);\n  font-weight: 700;\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
